
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import EmailVerify from "./pages/EmailVerify/EmailVerify";
import Error404 from "./pages/Error404/Error404";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import Home from "./pages/Home/Home";
import SendEmail from "./pages/SendEmail/SendEmail";
import Signin from "./pages/Signin/Signin";
import Signup from "./pages/Signup/Signup";
import { useAppSelector } from "./store/hook";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import ProductList from "./pages/Products/productList";
const App = () => {

  let token: string = useAppSelector((state) => state.auth).token || "";
  if (!token) {
    token = localStorage.getItem("token") || '';
  }


  return (
    <Router>
      <Routes>
        {token ?
          <Route path="/" element={<Home />} >
            {/* <Route path="profile" element={<Navigate replace to="/change-password" />} /> */}
            <Route path="/" element={<ProductList />} />
            <Route path="change-password" element={<ChangePassword />} />
          </Route>
          : <Route path="/" element={<Navigate replace to="/signin" />} />
        }

        <Route path="/send-verify-mail" element={<SendEmail />} />
        <Route path="/email-verify/:token" element={<EmailVerify />} />

        <Route
          path="/signin"
          element={!token ? <Signin /> : <Navigate to="/" />}
        />

        <Route
          path="/signup"
          element={!token ? <Signup /> : <Navigate to="/" />}
        />

        <Route
          path="/forgot-password-verify/:token"
          element={<ResetPassword />}
        />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="*" element={<Error404 />} />
      </Routes>
    </Router>
  );
};

export default App;
